export const formatTextValue = (value: unknown): string => {
  if (typeof value === "string") {
    const normalized = value.trim();
    return normalized.length > 0 ? normalized : "—";
  }

  if (value == null) {
    return "—";
  }

  return String(value);
};
